import { useEffect, useState } from "react";
import designBack from "../../src/images/cyber-back.png";
import "./main.css";
import CourseCards from "./courseCards";
import Header from "./header/header";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import FlipCard from "./flipCard";
import { ICourseDetails } from "./EnrollTypes";
import { useCourses } from "./Contexts/CoursesContext";
import { PopulateContext, checkIfInDecember} from "../App";

function CyberSecurity() {
  const [ready, setReady] = useState(false);
  const [allCourses, setAllCourses] = useState<ICourseDetails[]>([]);
  const { courses, setCoursesContext } = useCourses();
  const {weAreInDecember} = checkIfInDecember();
  let navigate = useNavigate();

  const navigateEngeneering = () => {
    navigate("/SchoolofEngineering");
  };
  const navigateDesign = () => {
    navigate("/SchoolofDesign");
  };
  const navigateData = () => {
    navigate("/SchoolofData");
  };
  const navigateMarketing = () => {
    navigate("/SchoolofMarketing");
  };
  const navigateProduct = () => {
    navigate("/SchoolofProduct");
  };
  const navigateNoCode = () => {
    navigate("/nocode");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!courses) {
          const value = await PopulateContext("Courses");
          if (value) {
            const newValue = value.filter(
              (each: any) =>
                each.isDeleted === false && each.isArchive === false
            );
            setCoursesContext(newValue);
          }
        }
        const filtered: any = courses?.filter(
          (course) => course.Category === "cybersecurity"
        );
        setAllCourses(filtered);
        setReady(true);
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchData();
  }, [courses, setCoursesContext]);

  return (
    <>
      {ready ? (
        <div className="homemain">
          <Header />
          {/* <div className="headmid"></div> */}
          <div
            className="relative w-full h-[512px]"
            style={{
              backgroundImage: `url(${designBack})`,
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-start p-4 sm:p-8 md:p-12 lg:p-16">
              <div
                style={{ maxWidth: "550px" }}
                className="text-left text-white p-8 my-20 md:m-12 lg:m-16 rounded-lg bg-[#884405F2] bg-opacity-75"
              >
                <div className="flex justify-between">
                  <h3 className="text-base sm:text-lg">
                    Welcome to Doyenify Academy
                  </h3>
                  {weAreInDecember && <div className="border rounded-full bg-green-500 border-green-500  p-2 flex items-center justify-end shadow-md">
                    <img
                      alt="doyenify academy logo"
                      src="../../images/hat.png"
                      className="w-10 rounded-full object-contain"
                    />
                  </div>}
                </div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mt-2">
                  School of CyberSecurity
                </h1>
                <p className="mt-4 text-justify text-xs sm:text-sm md:text-base lg:text-base xl:text-base">
                  This school offers cutting-edge courses designed to equip
                  students with the skills needed to protect digital assets and
                  secure networks.
                </p>
              </div>
            </div>
          </div>
          <div className="py-10" style={{ backgroundColor: "#F2FFD8" }}>
            <div>
              <h4
                className="text-center"
                style={{
                  fontSize: "34px",
                  fontWeight: "600",
                  paddingTop: "17px",
                  paddingBottom: "17px",
                  color: "#0F4B16",
                }}
              >
                CyberSecurity Courses
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 m-10">
                {allCourses?.map((course: any) => (
                  <div key={course.id} className="course-card">
                    <CourseCards
                      key={course.id}
                      CourseName={course.CourseName}
                      CourseImage={course.CourseImage}
                      id={course.id}
                      Duration={course.Duration}
                      Color={course.Color}
                      CourseColor={course.CourseColor}
                      disablebtn={course.disablebtn}
                      ShortDescription={course.ShortDescription}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="pt-12">
              <h4
                className="text-center"
                style={{
                  fontSize: "34px",
                  fontWeight: "600",
                  paddingTop: "17px",
                  paddingBottom: "17px",
                  color: "#0F4B16",
                }}
              >
                Other Schools
              </h4>
              <div className="flex justify-center">
                <div className="text-center grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-3 mx-4 md:mx-20">
                  <FlipCard
                    frontImg="../../images/software-eng.png"
                    backImg="../../images/eng-img.png"
                    title="Engineering"
                    handleClick={navigateEngeneering}
                  />
                  <FlipCard
                    frontImg="../../images/data-science.png"
                    backImg="../../images/science-img.png"
                    title="Data Science"
                    handleClick={navigateData}
                  />
                  <FlipCard
                    frontImg="../../images/product-design.png"
                    backImg="../../images/design-img.png"
                    title="Product Design"
                    handleClick={navigateDesign}
                  />
                  <FlipCard
                    frontImg="../../images/product-management.png"
                    backImg="../../images/management-img.png"
                    title="Product Management"
                    handleClick={navigateProduct}
                  />
                  <FlipCard
                    frontImg="../../images/marketing.png"
                    backImg="../../images/marketing-img.png"
                    title="Marketing"
                    handleClick={navigateMarketing}
                  />
                  <FlipCard
                    frontImg="../../images/no-code.png"
                    backImg="../../images/no-code-img.png"
                    title="No-code"
                    handleClick={navigateNoCode}
                  />
                  <div className="flip-card w-full max-w-xs mx-auto h-80">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <div className="relative w-full">
                          <img
                            src="../../images/video.png"
                            alt="videography"
                            className="rounded-lg shadow-md w-full h-80"
                          />

                          {/* Overlay for Santa Claus image at the top right */}
                          <div className="absolute top-0 right-0 px-4 py-4">
                            <div className="border rounded-full bg-green-500 border-green-500 p-2 flex items-center justify-center shadow-md">
                              <img
                                alt="doyenify academy logo"
                                src="../../images/hat.png"
                                className="w-10 rounded-full object-contain"
                              />
                            </div>
                          </div>

                          {/* Centered title text */}
                          <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center">
                            <div className="text-center">
                              <h2 className="text-white px-10 text-base md:text-lg lg:text-3xl xl:text-3xl font-bold">
                                Videography
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="flip-card-back bg-gray-800 rounded-lg flex items-center justify-center h-full">
                        <div className="text-center">
                          <img
                            src="../../images/video-img.png"
                            alt="videography"
                            className="w-44 mx-auto"
                          />
                          <h2 className="text-white text-base md:text-lg lg:text-2xl xl:text-2xl font-bold">
                            Videography
                          </h2>
                          <p className="mt-4 text-lg text-[#047E35] py-2 px-4 rounded">
                            Coming soon
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      ) : (
        <div className="academystyle flex justify-center items-center min-h-screen">
          <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
          <ClipLoader size={50} color="#047E35" />
        </div>
      )}
    </>
  );
}

export default CyberSecurity;
